import React from "react";
import { connect } from "react-redux";
import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { catchException, commonActions } from "../../../redux/actions/common";
import { IAppState } from "../../../redux/reducers";
import MoreOptions from "../../shared-ui/more-options";
import { IPopupMenuOption } from "../../shared-ui/popup-menu";
import { IEnterpriseUser } from "../../../api/entities/enterprise-user";
import { enterpriseUserService } from "../../../api/services/enterprise-user-service";
import { InvitationStatus } from "../../../api/entities/invitation";

const mapStateToProps = (state: IAppState) => ({
    user: state.users.currentUser,
});

const mapDispatchToProps = (
    dispatch: ThunkDispatch<IAppState, void, Action>
) => {
    return {
        startLoading: () =>
            dispatch(commonActions.startLoading()),
        stopLoading: () =>
            dispatch(commonActions.stopLoading())
    };
};

export interface IMoreOptionProps
    extends ReturnType<typeof mapStateToProps>,
        ReturnType<typeof mapDispatchToProps> {
    data: IEnterpriseUser;

    fetchData: () => void;
}

export const MoreOption = connect(mapStateToProps, mapDispatchToProps)((props: IMoreOptionProps) => {
        function deactivateAccount() {
            props.startLoading();

            enterpriseUserService.revertUserAccountToIndividual(props.data.id).then(() => {
                props.fetchData();
            }).catch(catchException()).finally(props.stopLoading);
        }

        function updateUser() {
            props.startLoading();

            enterpriseUserService.updateUser(props.data.id, {
                isAdmin: !props.data.isAdmin
            }).then(() => {
                props.fetchData();
            }).catch(catchException()).finally(props.stopLoading);
        }

        function getOptions(): IPopupMenuOption[] {
            let result = [];

            if (!props.data.invitation || props.data.invitation.status === InvitationStatus.Accepted) {
                result.push({
                    label: `Convert To ${props.data.isAdmin ? 'Employee' : 'Admin'}`,
                    onClick: updateUser
                });
            }

            if (props.data.isActivated) {
                result.push({
                        label: "Deactivate",
                        onClick: deactivateAccount
                    }
                );
            }
            return result;
        }

        return (
            !(props.data.id === props.user.uid && props.data.isAdmin)
            && (!props.data.invitation || props.data.invitation.status === InvitationStatus.Accepted)
                ? <MoreOptions
                    options={getOptions()}
                />
                : <></>
        );
    }
);
